import React, {Component} from 'react';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

class CompletePage extends Component {


    render() {
        return (
            <div className='container'>
                <div className="card-container-form">
                    <div className="section-title">TPFA Accounts Application Confirmation</div>
                    <div className="input-group greyText fontSize">
                        <p>Thank you, you have completed your application for TPFA Accounts.</p>
                        {/*<p>You can download a document indicating the information you have captured using the link*/}
                        {/*below.</p>*/}
                    </div>
                    {/*<div>*/}
                    {/*<Button href={`data:application/pdf;base64,${document}`}*/}
                    {/*download={`BusinessOnlineProfile${Date.now()}.pdf`}>*/}
                    {/*Download Document*/}
                    {/*</Button>*/}
                    {/*</div>*/}
                </div>
            </div>
        )
    }
}

function mapStateToProps({accounts, individual: {individual}, businessOnline: {id, document}, impersonation, loading}) {
    return {
        id,
        impersonation: impersonation && impersonation.impersonation ? impersonation.impersonation : {},
        loading
    }
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators({}, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(CompletePage);